import React from "react";
import "./StatisticsSection.css";

const calculateExperience = () => {
  const foundingYear = 1984;
  const currentYear = new Date().getFullYear();
  return currentYear - foundingYear;
};

const StatisticsSection = () => {
  return (
    <section className="statistics-section py-5 text-center">
      <div className="container">
        <h2 className="section-title">Unsere Erfolge in Zahlen</h2>
        <div className="row">
          <div className="col-md-4 mb-4">
            <div className="stat-card">
              <h3 className="stat-number">120+</h3>
              <p className="stat-text">Mitglieder</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="stat-card">
              <h3 className="stat-number">{calculateExperience()}</h3>
              <p className="stat-text">Jahre Erfahrung</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="stat-card">
              <h3 className="stat-number">5+</h3>
              <p className="stat-text">Events pro Jahr</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;
